import {
    CONSENT_COOKIE_ACCEPTED_KEY,
    CONSENT_COOKIE_REJECTED_KEY,
    CONSENT_COOKIE_VALUE,
    CONSENT_REJECTED_TTL_DAYS,
    CONSENT_TTL_DAYS,
} from './consent.constants';

const DAY_SECONDS = 24 * 60 * 60;

const hasCookie = (key: string): boolean =>
    document.cookie.split(';').some((entry) => entry.trim() === `${key}=${CONSENT_COOKIE_VALUE}`);

function setCookie(key: string, maxAgeSeconds: number): void {
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    document.cookie = `${key}=${CONSENT_COOKIE_VALUE}; path=/; max-age=${maxAgeSeconds}; samesite=lax${secure}`;
}

function deleteCookie(key: string): void {
    document.cookie = `${key}=; path=/; max-age=0; samesite=lax`;
}

/** Whether either decision cookie is present in this document (client-side). */
export function hasConsentCookie(): boolean {
    if (typeof document === 'undefined') return false;

    return hasCookie(CONSENT_COOKIE_ACCEPTED_KEY) || hasCookie(CONSENT_COOKIE_REJECTED_KEY);
}

/**
 * Mirror "a decision exists" so the server can skip rendering the banner.
 * Writing one key always clears the other — they must never coexist.
 */
export function writeConsentCookie(accepted: boolean): void {
    if (typeof document === 'undefined') return;

    if (accepted) {
        deleteCookie(CONSENT_COOKIE_REJECTED_KEY);
        setCookie(CONSENT_COOKIE_ACCEPTED_KEY, CONSENT_TTL_DAYS * DAY_SECONDS);
        return;
    }

    deleteCookie(CONSENT_COOKIE_ACCEPTED_KEY);
    setCookie(CONSENT_COOKIE_REJECTED_KEY, CONSENT_REJECTED_TTL_DAYS * DAY_SECONDS);
}

export function clearConsentCookie(): void {
    if (typeof document === 'undefined') return;

    deleteCookie(CONSENT_COOKIE_ACCEPTED_KEY);
    deleteCookie(CONSENT_COOKIE_REJECTED_KEY);
}
